import React, { useEffect, useState } from "react";
import Footer from "../common/Footer";
import { useParams } from "react-router-dom";
import { apiConnector } from "../services/apiconnector";
import { categories } from "../services/apis";
import { getCatalogPageData } from "../services/operations/PageAndComponentData";
import CourseSlider from "../components/core/Catalog/CourseSlider";
import CourseCard from "../components/core/Catalog/Course_Card";
import { normalizeApiArray } from "../utils/normalizeApiArray";

const Catalog = () => {
  const { catalogName } = useParams();
  const [catalogPageData, setCatalogPageData] = useState(null);
  const [categoryId, setCategoryId] = useState("");
  const [active, setActive] = useState(1);

  // FetchAll categories
  useEffect(() => {
    const getCategories = async () => {
      try {
        const res = await apiConnector("GET", categories.CATEGORIES_API);
        const categoriesList = normalizeApiArray(res?.data?.allCategories);
        const matchedCategory = categoriesList.find(
          (category) =>
            category?.name?.split(" ").join("-").toLowerCase() === catalogName
        );
        setCategoryId(matchedCategory?._id || "");
      } catch (error) {
        console.log("could not fetch the category list", error);
        setCategoryId("");
      }
    };
    getCategories();
  }, [catalogName]);

  useEffect(() => {
    const getCategoryDetails = async () => {
      try {
        const res = await getCatalogPageData(categoryId);
        setCatalogPageData(res);
      } catch (error) {
        console.log(error);
      }
    };

    if (categoryId) {
      getCategoryDetails();
    }
  }, [categoryId]);

  return (
    <>
      <section className="catalog-hero">
        <div className="catalog-hero-shape catalog-hero-shape-one" />
        <div className="catalog-hero-shape catalog-hero-shape-two" />
        <div className="catalog-hero-inner">
          <div className="catalog-hero-copy">
            <p className="catalog-breadcrumb">Home <span>/</span> Courses <span>/</span> {catalogPageData?.data?.selectedCategory?.name || "Explore"}</p>
            <span className="catalog-eyebrow">Structured market learning</span>
            <h1>{catalogPageData?.data?.selectedCategory?.name || "Explore Courses"}</h1>
            <p>{catalogPageData?.data?.selectedCategory?.description || "Build practical trading knowledge through clear lessons, guided practice and a disciplined learning path."}</p>
          </div>
          <div className="catalog-hero-visual" aria-hidden="true">
            <div className="catalog-chart-card"><span>LEARN • PRACTISE • GROW</span><div className="catalog-bars">{[42,68,54,82,64,92,76].map((height,index)=><i key={index} style={{height:`${height}%`}} />)}</div><b>Build skills step by step</b></div>
          </div>
        </div>
      </section>

      {/* Section 2 */}
      <div className="mx-auto box-content w-full lg:max-w-maxContent px-4 py-12">
        {/* Sub Sec 1 */}
        <p className="sm:text-4xl text-3xl text-richblack-5 font-semibold">
          Courses to get you started
        </p>

        <div className="my-4 flex border-b border-b-richblack-600 text-sm">
          <p
            className={`px-4 py-2 cursor-pointer ${
              active === 1
                ? "border-b border-b-yellow-25 text-yellow-25"
                : "text-richblack-50"
            }`}
            onClick={() => setActive(1)}
          >
            Most Popular
          </p>
          <p
            className={`px-4 py-2 cursor-pointer ${
              active === 2
                ? "border-b border-b-yellow-25 text-yellow-25"
                : "text-richblack-50"
            }`}
            onClick={() => setActive(2)}
          >
            New
          </p>
        </div>

        <div className="mr-8 xl:mr-0">
          <CourseSlider
            courses={catalogPageData?.data?.selectedCategory?.course}
          />
        </div>
      </div>

      {/* Sub Sec 2 */}
      <div className="mx-auto box-content w-full  lg:max-w-maxContent px-4 py-12">
        <p className="sm:text-4xl text-3xl text-richblack-5 font-semibold">
          Top Courses in {catalogPageData?.data?.differentCategory?.[0].name}
        </p>
        <div className="py-8 mr-8 xl:mr-0">
          <CourseSlider
            courses={catalogPageData?.data?.differentCategory?.[0]?.course}
          />
        </div>
      </div>

      {/* Sub Section 3 */}
      <div className="mx-auto lg:max-w-maxContent box-content w-full px-4 py-12 ">
        <div className="sm:text-4xl text-3xl text-richblack-5 font-semibold">
          Frequently Bought
        </div>
        <div className="py-8 mr-8 xl:mr-0">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            {catalogPageData?.data?.mostSellingCourses
              ?.slice(0, 6)
              .map((course, index) => (
                <CourseCard course={course} key={index} Height={"h-[250px]"} />
              ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Catalog;
